/**
 * Simple screen router.
 * Manages which screen is currently rendered.
 */

export type Screen =
  | 'menu'
  | 'lobby'
  | 'setup'
  | 'round-interstitial'
  | 'turn-waiting'
  | 'turn-active'
  | 'turn-end'
  | 'protest'
  | 'round-complete'
  | 'game-end'
  | 'rules'
  | 'join'
  // Multi-device screens
  | 'multi-new-game'
  | 'multi-join'
  | 'multi-lobby-host'
  | 'multi-lobby-joiner'
  | 'multi-setup'
  | 'multi-round-interstitial'
  | 'multi-turn-waiting'
  | 'multi-turn-active'
  | 'multi-turn-end'
  | 'multi-round-complete'
  | 'multi-game-end'
  // Custom deck
  | 'custom-deck'
  // Mid-round transition
  | 'mid-round-transition'
  // Admin (secret)
  | 'admin-stats';

type ScreenRenderer = () => void;

const renderers: Map<Screen, ScreenRenderer> = new Map();

let currentScreen: Screen = 'menu';

export function registerScreen(screen: Screen, renderer: ScreenRenderer): void {
  renderers.set(screen, renderer);
}

export function navigate(screen: Screen): void {
  currentScreen = screen;
  const renderer = renderers.get(screen);
  if (renderer) {
    renderer();
  } else {
    console.warn(`No renderer registered for screen: ${screen}`);
  }
}

export function getCurrentScreen(): Screen {
  return currentScreen;
}
